export const SUPER_ADMIN_EMAIL="sajukumarnair.sukumarannair@vodafone.com"

export const SIGN_IN_STATUS = {
    SUCCESS : "SUCCESS",
    INVALID_CREDENTIALS : "INVALID_CREDENTIALS",
    MFA_DISABLED : "MFA_DISABLED",
    UNVERIFIED_EMAIL: "UNVERIFIED_EMAIL",
    TOO_MANY_REQUEST : "TOO_MANY_REQUEST",
    INVALID_VERIFICATION_CODE:"INVALID_VERIFICATION_CODE",
    MISSING_VERIFICATION_CODE:"MISSING_VERIFICATION_CODE",
    RECAPTCHA_ISSUE:"RECAPTCHA_ISSUE",
    REQUIRES_RECENT_LOGIN:"REQUIRES_RECENT_LOGIN",
    CUSTOMER_USER_DISABLED:"CUSTOMER_USER_DISABLED",
    VF_USER_DISABLED:"VF_USER_DISABLED",
    CLOSE_POPUP:"CLOSE_POPUP",
    PASSWORD_POLICY:"PASSWORD_POLICY",
}

export const SIGN_IN_ERROR_MESSAGES = {
    SUCCESS : "success",
    CUSTOMER_USER_DISABLED:`Your account has been suspended due to prolonged inactivity or security concerns. Please contact your <b>Organisation’s Account Manager</b> or <b>Vodafone Account Manager</b> for assistance.`,
    VF_USER_DISABLED:`Your account has been suspended due to prolonged inactivity or security concerns. For assistance, please contact the <b>Admin</b> at <b>${SUPER_ADMIN_EMAIL}</b> or <b>mihai.costache@vodafone.com</b>.`,
    INVALID_CREDENTIALS : "Invalid email or password",
    MFA_DISABLED : "Multifactor authentication disabled",
    UNVERIFIED_EMAIL: "Please verify your email",
    TOO_MANY_REQUEST : "Please wait few minutes before you try again",
    // INVALID_VERIFICATION_CODE:"Enter the correct verification code sent on your registered mobile number",
    INVALID_VERIFICATION_CODE:"The verification code you entered is incorrect. Please log in again.",
    MISSING_VERIFICATION_CODE:"Enter the verification code sent on your registered mobile number",
    // RECAPTCHA_ISSUE:"Somthing went wrong. Please refresh the page and try again",
    RECAPTCHA_ISSUE:" Something went wrong. Please try again later.",
    // INVALID_PHONE_NUMBER:"Invalid phone number",
    INVALID_PHONE_NUMBER:"The phone number entered is invalid. Please check and try again.",
    ALREADY_2FA_ENROLLED:"Phone number is already enrolled for second factor authentication for this account",
    // REQUIRES_RECENT_LOGIN:"Too many wrong attempts. Please login again",
    REQUIRES_RECENT_LOGIN:"It appears that your session has expired. Please log in again.",
    INVALID_APP_CREDENTIALS:"We encountered an issue while sending the verification code to your preferred method. If the issue persists, please select an alternative method to receive the verification code.",
    INTERNAL_ERROR:"We encountered an issue while sending the verification code to your preferred method. If the issue persists, please select an alternative method to receive the verification code.",
    PASSWORD_POLICY:`<div>Your password must meet the following security requirements to ensure account protection:</div>
        <div style="margin-bottom: 8px;">
            <li>Minimum of <b>8 characters</b></li>
            <li>At least <b>one uppercase letter (A–Z)</b></li>
            <li>At least <b>one lowercase letter (a–z)</b></li>
            <li>At least <b>one numeric digit (0-9)</b></li>
            <li>At least <b>one special character</b> (e.g. @, #, $, etc.)</li>
        </div>
        <div>If your password does not meet the above criteria, you may be prompted to reset it. Please use the <b>"Reset Password”</b> option available on the login page to initiate the reset process.</div>
    `,
}

export const EMAIL_SIGN_IN_STATUS = {
    SUCCESS : "SUCCESS",
    INCORRECT_OTP : "INCORRECT_OTP",
    OTP_EXPIRED:"OTP_EXPIRED",
    MISSING_OTP:"MISSING_OTP",
}

export const EMAIL_SIGN_IN_ERROR_MESSAGES = {
    INVALID_VERIFICATION_CODE:"The verification code you entered is incorrect. Please log in again.",
    MISSING_VERIFICATION_CODE:"Enter the verification code sent on your registered Email.",
    EXPIRE_VERIFICATION_CODE:"The verification code you entered has expired. Please log in again.",
    TOO_MANY_REQUEST:"Too many attempts. Please wait few minutes before you try again.",
    SERVER_ISSUE:" Something went wrong. Please try again later.",
}